<style lang="less">
  .item-tips {
    font-size: 13px;
    line-height: 13px;
    color: #a3a3a3;
  }
  .custom-error-bc textarea {
    border-color: #f56c6c;
  }
  .custom-error-bc textarea:hover {
    border-color: #f56c6c;
  }
  .custom-error-bc textarea:focus {
    border-color: #f56c6c;
  }
  .custom-error-mb-def {
    margin-bottom: 22px;
  }
  .custom-error-mb-cus {
    margin-bottom: 6px;
  }
</style>

<template>
  <el-card>
    <div slot="header">
      <h1>{{ activity ? '“' + activity.activityName + '”' : '' }}页面设置</h1>
    </div>
    <el-tabs type="card" v-model="tabName" @tab-click="handleClick" :before-leave="handleLeave">
      <el-tab-pane label="首页显示设置" name="home-show">首页显示设置</el-tab-pane>
      <el-tab-pane label="轮播图" name="carousel-list">轮播图</el-tab-pane>
      <el-tab-pane label="本月主打" name="flagship">
        <div style="padding: 0 20px;margin-top: 25px">
          <el-form ref="form" :model="form" :rules="rules" @validate="formValidate" v-loading="loading" label-width="110px">
            <el-form-item label="主打商品：" prop="mainProducts" :class="customMarginBottom(customError.mainProducts)">
              <el-input type="textarea" v-model="form.mainProducts" rows="3" @blur="customErrorClean" :class="customError.mainProducts ? 'custom-error-bc': ''" style="width: 500px"></el-input>
              <div v-if="customError.mainProducts" class="el-form-item__error" v-html="customError.mainProducts" style="position: static"></div>
            </el-form-item>
            <el-form-item label="">
              <div class="item-tips">主打商品设置，可录入商品编码，多个编码使用英文“,”隔开</div>
            </el-form-item>
            <el-form-item style="margin-top: 40px">
              <el-button type="primary" @click="onSubmit">提交</el-button>
            </el-form-item>
          </el-form>
        </div>
      </el-tab-pane>
      <el-tab-pane label="商品推荐" name="recommend">商品推荐</el-tab-pane>
    </el-tabs>
  </el-card>
</template>

<script>
  import { createNamespacedHelpers } from 'vuex'
  import _ from 'lodash'
  import store from '@/store'
  const { mapGetters } = createNamespacedHelpers('activityPagesettings')

  export default {
    data() {
      return {
        tabName: 'flagship',
        activity: null,
        loading: false,
        isEdit: false,
        isChange: false,
        id: 0,
        form: {
          mainProducts: ''
        },
        customError: {
          mainProducts: ''
        }
      }
    },
    inject: ['reload'],
    computed: {
      rules() {
        const checkMainProducts = (rule, value, callback) => {
          let valueFormat = this.formatMainProducts(value)
          if (valueFormat === '') {
            callback()
          } else {
            if (!(/^([0-9A-Za-z\-]+,)*([0-9A-Za-z\-]+),?$/.test(valueFormat))) {
              callback(new Error('商品编码格式错误'))
            } else {
              valueFormat = valueFormat.replace(/,$/, '')
              const valueArr = valueFormat.split(',')
              if (valueArr.length > 12) {
                callback(new Error('商品编码最多12个'))
              } else {
                const filterUnique = arr => arr.filter(i => arr.indexOf(i) !== arr.lastIndexOf(i))
                const duplication = arr => [...new Set(arr)]
                const uniqueValueArr = duplication(filterUnique(valueArr))
                if (uniqueValueArr.length) {
                  callback(new Error('商品编码重复：' + uniqueValueArr.join('，')))
                } else {
                  callback()
                }
              }
            }
          }
        }
        return {
          mainProducts: [{ validator: checkMainProducts, trigger: 'blur' }]
        }
      },
      ...mapGetters(['collection'])
    },
    methods: {
      handleClick(tab) {
        if (tab.name != this.tabName) {
          if (this.isChange) {
            this.$confirm('您当前编辑结果未提交，是否确定离开？', '提示', {
              type: 'warning'
            }).then(() => {
              this.$router.push({ name: 'activity-activity-pagesetting-' + tab.name, query: { activityId: this.activity.id }})
            }).catch(() => {
              return false
            })
          } else {
            this.$router.push({ name: 'activity-activity-pagesetting-' + tab.name, query: { activityId: this.activity.id }})
          }
        }
      },
      handleLeave() {
        return false
      },
      formValidate() {
        this.isChange = true
      },
      async checkSubmit() {
        try {
          await new Promise((resolve, reject) => {
            this.$refs['form'].validate((valid) => {
              valid ? resolve(true) : reject(false)
            })
          })
          await new Promise(async (resolve, reject) => {
            const mainProductsArr = this.formatMainProductsArr(this.form.mainProducts)
            if (mainProductsArr.length) {
              await this.$store.dispatch('activityApply/checkMainProducts', { activityId: this.activity.id, mainProducts: mainProductsArr }).then(res => {
                if (res.code) {
                  this.customError.mainProducts = this.formatCustomErrorMainProducts(res.errMsg, res.defectMainProducts)
                  reject(false)
                } else {
                  resolve(true)
                }
              })
            } else {
              resolve(true)
            }
          })
        } catch (e) {
          return false
        }
        return true
      },
      async onSubmit() {
        const checkSubmit = await this.checkSubmit()
        if (!checkSubmit) {
          return false
        }
        const formData = _.cloneDeep(this.form)
        const formatFormData = this.formatFormData(formData)
        const pushFormData = {
          activityId: this.activity.id,
          stage: 'home',
          name: 'flagship',
          content: formatFormData
        }
        this.isEdit ? pushFormData.id = this.id : pushFormData
        try {
          await this.$store.dispatch(this.isEdit ? 'activityPagesettings/update' : 'activityPagesettings/create', pushFormData)
          this.$message.success('提交成功')
          this.reload()
        } catch (err) {
          this.$message.error(err.response.data.message)
        }
        this.loading = false
      },
      async init() {
        const query = {
          activityId: this.activity.id,
          stage: 'home',
          name: 'flagship'
        }
        const { collection } = await this.$store.dispatch('activityPagesettings/collection', { query })
        if (collection.length) {
          this.isEdit = true
          this.initForm()
        }
      },
      formatMainProducts(value) {
        value = value.replace(/[\s]/g, '')
        return value
      },
      formatMainProductsArr(value) {
        value = this.formatMainProducts(value)
        value = value.replace(/,$/, '')
        if (value !== '') {
          if (/^([0-9A-Za-z\-]+,)*([0-9A-Za-z\-]+)$/.test(value)) {
            return value.split(',')
          } else {
            return []
          }
        } else {
          return []
        }
      },
      formatFormData(formData) {
        formData.mainProducts = this.formatMainProductsArr(formData.mainProducts)
        return formData
      },
      formatCustomErrorMainProducts(errMsg, defectMainProducts) {
        let mainProductsErrMsg = errMsg
        if (defectMainProducts.length) {
          mainProductsErrMsg += '：'
          defectMainProducts.forEach((item, index) => {
            mainProductsErrMsg += item + '，'
            if (index % 3 == 2) {
              mainProductsErrMsg += '<br/>'
              mainProductsErrMsg += index ? '&nbsp;'.repeat(28) : ''
            }
          })
          mainProductsErrMsg = mainProductsErrMsg.replace(/(&nbsp;)*$/, '')
          mainProductsErrMsg = mainProductsErrMsg.replace(/(<br\/>)$/, '')
          mainProductsErrMsg = mainProductsErrMsg.replace(/，$/, '')
        }
        return mainProductsErrMsg
      },
      initForm() {
        const document = _.cloneDeep(this.collection[0])
        this.id = document.id
        const initForm = _.cloneDeep(document.content)
        const mainProductsArr = initForm.mainProducts
        let mainProductsFormat = ''
        if (mainProductsArr.length) {
          mainProductsArr.forEach((item, index) => {
            mainProductsFormat += item + ','
            if (index % 4 == 3) {
              mainProductsFormat += "\n"
            }
          })
          mainProductsFormat = mainProductsFormat.replace(/[\n]$/, '')
        }
        initForm.mainProducts = mainProductsFormat
        this.form = initForm
      },
      customErrorClean() {
        this.customError.mainProducts = ''
      },
      customMarginBottom(errMsg) {
        const lineCount = errMsg ? (errMsg.match(/(<br\/>)/) ? errMsg.match(/(<br\/>)/).length + 1 : 1) : 0
        return lineCount ? 'custom-error-mb-cus' : 'custom-err-mb-def'
      }
    },
    async mounted() {
      const { activityId = 0 } = this.$route.query
      try {
        const { document } = await this.$store.dispatch('activities/document', activityId)
        this.activity = document
      } catch (err) {
        this.$message.error('活动不存在')
        this.$router.push({ name: 'activity-activity' })
      }
      this.init()
    }
  }
</script>
